import { NavLink } from 'react-router-dom';
import { Button } from '../../components/buttons/buttons';
import Heading from '../../components/heading/heading';
import { Main } from '../styled';
import { ErrorWrapper } from './style';

function NotFound() {
  return (
    <Main>
      <ErrorWrapper>
        <img src={require(`../../static/img/pages/maintenance.svg`).default} alt="404" />
        <Heading className="error-text" as="h3">
          404
        </Heading>
        <p>¡Lo sentimos! La página que estás buscando no existe.</p>
        <NavLink to="/admin">
          <Button size="default" type="primary" to="/admin">
            Volver al inicio
          </Button>
        </NavLink>
      </ErrorWrapper>
    </Main>
  );
}

export default NotFound;
